import React from "react"
import TextBlock from "../index"

const Info = ({ children, padding }) => {
  return <TextBlock theme="info" children={children} padding={padding} />
}

export default Info
